<template>
  <div class="date-time-picker">
    <div v class="input-field date z-depth-1">
      <input
        type="text"
        class="datepicker"
        :placeholder="
          $store.state.user.langEng
            ? 'day/month, 2020-12-24, 200101, 20-01-01, 20 01 01, 20/01/01'
            : 'dag/månad, 2020-12-24, 200101, 20-01-01, 20 01 01, 20/01/01'
        "
        :value="date.toISOString().slice(0, 10)"
        @blur="validateDate"
        @click="closeDatePicker"
        @keydown.arrow-up.prevent
        @keydown.arrow-down.prevent
        @keyup.arrow-down="handleClickDown"
        @keyup.arrow-up="handleClickUp"
      />
      <span class="calendar-icons">
        <i class="material-icons" @click="setDateToToday">today</i>
        <i class="material-icons date-range" @click="openDatePicker"
          >date_range</i
        >
      </span>
    </div>
    <div class="input-field time z-depth-1">
      <input
        type="text"
        class="timepicker"
        placeholder="09:00, 0900, 9, 15, 930, 9:30"
        v-model="time"
        @blur="validateTime"
        @click="closeTimePicker"
      />
      <span>
        <i class="material-icons" @click="openTimePicker">schedule</i>
      </span>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import $ from "jquery";
import { FormatDateTimeHelper } from "./FormatDateTimeHelper";

@Component
export default class ArticleTimePicker extends Vue {
  @Prop() updateTime;
  @Prop() setTime;
  time = "";
  date = new Date();
  dateTimeHelper = new FormatDateTimeHelper();

  @Watch("setTime")
  setNewTime(time) {
    if (!this.onInit) {
      this.onInit = true;
      this.time = new Date(time ? time : Date.now())
        .toTimeString()
        .substr(0, 5);
      if (this.time.substr(0, 2) == "00") {
        this.time = "01:00";
      }
      this.date = new Date(time ? time : Date.now());
      setTimeout(() => {
        this.dontEmitOnInitialize = true;
      }, 100);
    }
  }

  @Watch("updateTime")
  triggerUpdateTime() {
    this.emitNewDateTime();
  }

  @Watch("date", {
    immediate: true,
  })
  @Watch("time")
  handleTime() {
    this.emitNewDateTime();
  }

  handleDate() {
    this.emitNewDateTime();
  }

  validateDate(e) {
    if (!this.date) return;

    let target = new Date(e.target.value)
    target.setFullYear(new Date().getFullYear())
    
    let value = this.dateTimeHelper.validateDate(target.toISOString().slice(0, 10));
    if (value) {
      this.date = new Date(value);
      $(".date").removeClass("not-validated");
      $(".date").addClass("validated");
      setTimeout(() => {
        $(".date").removeClass("validated");
      }, 2000);
    } else {
      $(".date").removeClass("validated");
      $(".date").addClass("not-validated");
    }
  }

  validateTime(e) {
    let value = this.dateTimeHelper.validateTime(e.target.value);
    if (value) {
      this.time = value;
      $(".time").removeClass("not-validated");
    } else {
      $(".time").addClass("not-validated");
    }
  }

  emitNewDateTime() {
    if (!this.dontEmitOnInitialize) {
      return;
    }
    clearTimeout(this.throttleEmitTime);
    this.throttleEmitTime = setTimeout(() => {
      this.$emit(
        "newDateTime",
        new Date(this.date.toISOString().slice(0, 10) + " " + this.time).getTime()
      );
    }, 200);
  }

  handleClickDown(e) {
    let updateDateString = this.dateTimeHelper.changeToPreviousDay(
      e.target.value
    );
    this.date = updateDateString;
  }

  handleClickUp(e) {
    let updateDateString = this.dateTimeHelper.changeToNextDay(e.target.value);
    this.date = updateDateString;
  }

  setDateToToday() {
    let element = document.querySelector(".datepicker");
    element.focus();
    $(".date").removeClass("not-validated");
    setTimeout(() => {
      this.date = new Date();
    }, 0);
  }

  closeDatePicker() {
    setTimeout(() => {
      let date = document.querySelector(".datepicker");
      this.$M.Datepicker.getInstance(date).close();
      date.focus();
    }, 0);
  }

  openDatePicker() {
    let date = document.querySelector(".datepicker");
    let instance = this.$M.Datepicker.getInstance(date)
    instance.open();
    setTimeout(() => {
      instance.gotoDate(new Date(this.date));
      instance.setDate(new Date(this.date));
    }, 0);
  }

  closeTimePicker() {
    setTimeout(() => {
      let time = document.querySelector(".timepicker");
      this.$M.Timepicker.getInstance(time).close();
      time.focus();
    }, 0);
  }

  openTimePicker() {
    let time = document.querySelector(".timepicker");
    this.$M.Timepicker.getInstance(time).open();
  }

  initDatePicker() {
    let date = document.querySelector(".datepicker");
    this.$M.Datepicker.init(date, {
      format: "yyyy-mm-dd",
      defaultDate: this.date,
      setDefaultDate: true,
      autoClose: true,
      onSelect: d => {
        d.setHours(d.getHours() + 2)
        this.date = d
      },
      onOpen: () => {
        document.querySelector('#header-content').style.zIndex = 1
      },
      onClose: () => {
        document.querySelector('#header-content').style.zIndex = 5
      }
    });
  }

  initTimePicker() {
    let time = document.querySelector(".timepicker");
    this.$M.Timepicker.init(time, {
      twelveHour: false,
      autoClose: true,
      onSelect: (h, m) => {
        this.time = h + ':' + m
      },
      onOpenStart: () => {
        document.querySelector('#header-content').style.zIndex = 1
      },
      onCloseEnd: () => {
        document.querySelector('#header-content').style.zIndex = 5
      }
    });
  }

  mounted() {
    setTimeout(() => {
      this.initDatePicker();
      this.initTimePicker();
    }, 0);
  }
}
</script>

<style lang="scss">
.date-time-picker {
  display: grid;
  column-gap: 10px;
  grid-template-columns: 70% 30%;
  margin: 0.5em 0 0;
  padding-right: 0.7em;
  .input-field {
    align-items: center;
    display: flex;
    input {
      padding-left: 0.5em !important;
    }
  }
  .input-field.time span i {
    cursor: pointer;
    margin-right: 0.3em;
    padding-top: 6px;
    user-select: none;
    &:hover {
      color: gray;
    }
  }
  .date {
    border-radius: 5px;
    grid-column: 1/2;
    .calendar-icons {
      align-items: center;
      display: flex;
      margin-right: 0.5em;
      i {
        cursor: pointer;
        &:hover {
          color: gray;
        }
        user-select: none;
      }
      .date-range {
        margin-bottom: 2px;
      }
    }
  }
  .time {
    border-radius: 5px;
    grid-column: 2/3;
  }
  .date.not-validated,
  .time.not-validated {
    border: 2px solid red !important;
    box-shadow: 0 0 5px 0 red !important;
  }
}

@media (max-width: 992px) {
  .date-range {
    margin-bottom: 1px !important;
  }
}

// .error-outline {
//     border: 2px solid rgba(255, 0, 0, 0.726) !important;
//     -webkit-box-shadow: 0 0 5px 0 red !important;
//     box-shadow: 0 0 5px 0 red !important;
// }

// OLD STYLES BELOW
// --------------------------
// .date-time-picker {
//   position: relative;
//   display: flex;
//   flex-direction: row;
//   min-width: 300px;
//   input {
//     cursor: pointer;
//   }
//   .v-text-field {
//     padding: 0;
//     padding-top: 8px;
//   }
//   .date-pick,
//   .time-pick {
//     z-index: 50;
//   }
//   .date-pick {
//     .v-menu__content {
//       overflow-y: hidden !important;
//     }
//   }
//   .time-pick {
//     max-width: 100px;
//   }
// }
</style>
